import { Grid, Tooltip } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import EnhancedTable from "components/shared/Table";
import generateHeadCells from "helper/generate-head-cell";
import useHttp from "hooks/use-http";
import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StyledIconButton } from "styles/globals";
import { IMG_BASE_URL } from "constants";
import { Delete, Image, LocalOffer } from "@mui/icons-material";
import { useEffect } from "react";
import LoadingCM from "components/shared/Loading";
import PaginationCM from "components/shared/Pagination";
import { deleteBlogByIdRequest, getBlogsRequest } from "api/blogs";
import FilterDataCm from "components/shared/FilterDataCm";
import { categoriesData } from "constants/category";
import Toast from "helper/toast";
import DeleteModal from "components/shared/Modal/Delete";

const headCell = generateHeadCells("blogs_list");

const FILTER_INPUTS = [
  {
    id: "search",
    label: "جست و جو",
  },
  {
    id: "category",
    label: "منطقه",
    selectItems: [{ value: "*", title: "همه" }, ...categoriesData],
    type: "select",
  },
  {
    id: "sub_category",
    label: "محله",
    selectItems: [
      { value: "*", title: "همه" },
      ...categoriesData[0].subCategories,
    ],
    type: "select",
    selectFilterCondition: "watch('category') === 1",
  },
];

export default function Blogs() {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState({
    id: null,
    open: false,
  });
  const [filterData, setFilterData] = useState(false);

  const [data, setData] = useState({
    count: 0,
    data: [{ content: "وبلاگی یافت نشد" }],
  });

  const { loading, request } = useHttp();

  const deleteAdvHandler = async () => {
    setModal({
      id: null,
      open: false,
    });
    const res = await request({
      url: deleteBlogByIdRequest,
      values: modal.id,
    });
    if (res) {
      Toast({ type: "delete", title: "وبلاگ" });
      getData();
    }
  };

  const showModalHandler = (id) => {
    setModal({
      id: id,
      open: true,
    });
  };

  const getData = async (
    hasFilter = false,
    removeFilter = false,
    data = false
  ) => {
    const queryData = data ? data : filterData;
    const query = hasFilter
      ? {
          page: hasFilter ? 1 : page,
          search: queryData?.search,
          category: queryData?.category,
          sub_category: queryData?.sub_category,
        }
      : { page: removeFilter ? 1 : page };
    const res = await request({
      url: getBlogsRequest,
      values: query,
    });

    if (res.count) {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        titel: item.title,
        tags: (
          <Tooltip title="تگ ها" placement="top">
            <StyledIconButton
              variant="countaind"
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/blog/${item.id}/tags`);
              }}
            >
              <LocalOffer />
            </StyledIconButton>
          </Tooltip>
        ),
        image: item?.image?.url ? (
          <StyledIconButton
            onClick={(e) => {
              e.stopPropagation();
              window.open(IMG_BASE_URL + item.image.url, "_blank");
            }}
          >
            <Image />
          </StyledIconButton>
        ) : (
          "ثبت نشده"
        ),
        date: item.created_at.string,
        delete: (
          <StyledIconButton
            variant="countaind"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              showModalHandler(item.id);
            }}
          >
            <Delete />
          </StyledIconButton>
        ),
      }));

      setData({
        data: transformedData,
        count: res.pages_count,
      });
    } else {
      setData({
        count: 0,
        data: [{ content: "وبلاگی یافت نشد" }],
      });
    }
  };

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <DrawerCM title="وبلاگ ها">
      <FilterDataCm
        setFilterData={setFilterData}
        getDataFn={getData}
        inputs={FILTER_INPUTS}
        setPage={setPage}
      />
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={4}>
          <EnhancedTable
            rows={data.data}
            page={page}
            headCells={headCell}
            title="لیست وبلاگ ها"
            tableBtn={[
              {
                route: "/blog/add",
              },
            ]}
            click={(id) => navigate("/blog/edit/" + id)}
          />
          <PaginationCM
            page={page}
            onChange={(_, page) => setPage(page)}
            pages={data.count}
          />
        </Grid>
      )}
      <DeleteModal
        show={modal.open}
        onClose={() =>
          setModal({
            id: null,
            open: false,
          })
        }
        onDelete={deleteAdvHandler}
      />
    </DrawerCM>
  );
}
